import serviceTypeCodes from 'constants/serviceTypeCodes';
export const EUROSTAR_CARRIERS = [serviceTypeCodes.EUROSTAR, serviceTypeCodes.GREENSPEED];
export const SNCB_CARRIER = [serviceTypeCodes.SNCB];

export const getIsEROnlyJourney = ({ booking = {} }) =>
  [...(booking?.outbound ?? []), ...(booking?.inbound ?? [])].every(({ serviceType }) => serviceType?.code === serviceTypeCodes.GREENSPEED);

export const getEurostarBookingItems = ({ booking = {} }) =>
  booking.inbound
    .concat(booking.outbound)
    .flat()
    .filter((l) => l.serviceType.code === serviceTypeCodes.EUROSTAR)
    .map((l) => l.products)
    .flat()
    .filter((p) => p.isCancelled === false)
    .map((p) => ({ ...p, __typename: 'BookingItem' }));

export const getHasNonEurostarExpiredTickets = ({ booking = {} }) =>
  [...(booking?.outbound ?? []), ...(booking?.inbound ?? [])]
    .filter((legs) => !legs.cancelled && !EUROSTAR_CARRIERS.includes(legs.serviceType?.code))
    .some((leg) => leg.products?.some((p) => p.isExpired && !p.cancelled));

export const filterCarriers = ({ legs = [], carriers = EUROSTAR_CARRIERS, containCarriers = true }) =>
  containCarriers
    ? legs.filter(({ serviceType }) => carriers.includes(serviceType?.code))
    : legs.filter(({ serviceType }) => !carriers.includes(serviceType?.code));

export const getEurostarTickets = ({ booking = {} }) =>
  filterCarriers({ legs: booking.inbound })
    .concat(filterCarriers({ legs: booking.outbound }))
    .concat(
      filterCarriers({ legs: booking.outbound })
        .filter((l) => l.addOnLeg)
        .map((l) => l.addOnLeg)
    )
    .concat(
      filterCarriers({ legs: booking.inbound })
        .filter((l) => l.addOnLeg)
        .map((l) => l.addOnLeg)
    )
    .flat()
    .map((l) => l.products)
    .flat()
    .filter((p) => p.isCancelled === false)
    .map((p) => ({ ...p, __typename: 'BookingItem' }))
    .map((p) => p.ticketNumber);

export const getNonEurostarUnexpiredTickets = ({ booking = {} }) =>
  filterCarriers({ legs: booking.inbound, containCarriers: false })
    .concat(filterCarriers({ legs: booking.outbound, containCarriers: false }))
    .concat(
      filterCarriers({ legs: booking.outbound, containCarriers: false })
        .filter((l) => l.addOnLeg)
        .map((l) => l.addOnLeg)
    )
    .concat(
      filterCarriers({ legs: booking.inbound, containCarriers: false })
        .filter((l) => l.addOnLeg)
        .map((l) => l.addOnLeg)
    )
    .flat()
    .map((l) => l.products)
    .flat()
    .filter((p) => p.isCancelled === false && !p.isExpired)
    .map((p) => ({ ...p, __typename: 'BookingItem' }))
    .map((p) => p.ticketNumber);

export const getHasSNCBTicketsUnavailable = ({ booking = {} }) =>
  filterCarriers({ legs: booking.inbound, carriers: SNCB_CARRIER })
    .concat(filterCarriers({ legs: booking.outbound, carriers: SNCB_CARRIER }))
    .concat(
      filterCarriers({ legs: booking.outbound, carriers: SNCB_CARRIER })
        .filter((l) => l.addOnLeg)
        .map((l) => l.addOnLeg)
    )
    .concat(
      filterCarriers({ legs: booking.inbound, carriers: SNCB_CARRIER })
        .filter((l) => l.addOnLeg)
        .map((l) => l.addOnLeg)
    )
    .flat()
    .map((l) => l.products)
    .flat()
    .some((p) => !p.isCancelled && !p.externalTicketNumber);
